import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { WithdrawalPendingRowState } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/Pending/WithdrawalPendingRow/WithdrawalPendingRow.state';
import { FormApprove } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/Pending/FormApprove/FormApprove';
import { FormReject } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/Pending/FormReject/FormReject';
import { ConfirmationInfo } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/Pending/ConfirmationInfo/ConfirmationInfo';
import {
    GridBodyRow,
    GridRow,
    GridItemRow,
    SmallerItemRow,
    ItemNotes,
} from 'src/components/FraudAndCompliance/AutomaticWithdrawals/CommonParts/GridRow.style';
import { ButtonOnInputSide } from 'src/domains/layouts/shared/buttons/Button.style';
import { WithdrawalHistory } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/CommonParts/WithdrawalHistory/WithdrawalHistory';
import { DateTime } from 'src_common/utils/time/time';

interface PropsType {
    withdrawalId: number;
}

export const formatCardDetails = (cardNumber: string, expires: string | undefined | null): string => {
    const defaultString = `${cardNumber} **** **** ****`;
    const expiresDate = expires ?? null;
    if (expiresDate === null) {
        return defaultString;
    }

    const formatedExpiresDate = DateTime.from(expiresDate)?.format('MM/YY');
    return `${formatedExpiresDate} ,${defaultString}`;
};

export const AutomaticWithdrawalPendingRow = observer(
    'AutomaticWithdrawalPendingRow',
    ({ withdrawalId }: PropsType): React.ReactElement | null => {
        const { models, automaticWithdrawalState } = useAppStateContext();

        const [state] = React.useState(
            () => new WithdrawalPendingRowState(automaticWithdrawalState, () => withdrawalId, models)
        );

        if (state.withdrawalModel === null || state.basicDataLocal === null) {
            return null;
        }

        const { title, name } = state.basicDataLocal;

        if (state.isHiddenRow === true) {
            return null;
        }

        return (
            <GridBodyRow>
                {state.confirmationType === null ? (
                    <GridRow data-test='withdrawal-row'>
                        <SmallerItemRow data-test='account-id'> {state.withdrawalModel.accountId}</SmallerItemRow>
                        <SmallerItemRow>
                            {' '}
                            {formatCardDetails(state.withdrawalModel.cardNumber, state.withdrawalModel.expires)}
                        </SmallerItemRow>
                        <SmallerItemRow> {`${title} ${name}`}</SmallerItemRow>
                        <GridItemRow>
                            {' '}
                            <FormReject state={state} />
                        </GridItemRow>
                        <GridItemRow>
                            {' '}
                            <FormApprove
                                state={state}
                                currency={state.withdrawalModel.currency}
                            />
                        </GridItemRow>
                        <WithdrawalHistory accountId={state.withdrawalModel.accountId} />
                        <ItemNotes data-test='withdrawal-note'>
                            <OldInput
                                formInputState={state.notesText}
                                model={state.notesTextModel}
                                placeholder='Add a note...'
                            />
                            {state.hideButtonOnReviewTab ? null : (
                                <ButtonOnInputSide
                                    version='secondary'
                                    size='regular'
                                    hasLabel={false}
                                    onClick={state.review30Days}
                                    data-test='review-button'
                                >
                                    Review in 30 days
                                </ButtonOnInputSide>
                            )}
                        </ItemNotes>
                    </GridRow>
                ) : (
                    <ConfirmationInfo
                        type={state.confirmationType}
                        onClick={state.onHide}
                    />
                )}
            </GridBodyRow>
        );
    }
);
